export const themes = ['primary', 'secondary', 'text', 'text-secondary', 'icon'] as const

export const types = ['button', 'submit'] as const
